import {
  WIDGET_SIZE_PRESETS,
  WidgetSize,
  getViewportConstrainedMaxHeight,
} from '@automation-suite/shared-clients-widget-variant';

export const defaultIframeStyles = {
  border: 'none',
  'box-sizing': 'border-box',
  position: 'fixed',
  'z-index': '99999',
};

const desktopDefaultStyles = {
  bottom: '0px',
  display: 'block',
  height: '208px',
  left: 'unset',
  maxHeight: '90%',
  maxWidth: '100%',
  right: '0px',
  width: '544px',
};

export type GetStylesParams = {
  offsetBottomPx?: number;
  offsetRightPx?: number;
  size?: WidgetSize;
};

export const getDesktopDefaultStyles = ({ offsetBottomPx = 0, offsetRightPx = 0 }: GetStylesParams) => ({
  ...desktopDefaultStyles,
  bottom: `calc(${desktopDefaultStyles.bottom} + ${offsetBottomPx}px)`,
  right: `calc(${desktopDefaultStyles.right} + ${offsetRightPx}px)`,
  maxHeight: `calc(${desktopDefaultStyles.maxHeight} - ${offsetBottomPx}px)`,
  maxWidth: `calc(${desktopDefaultStyles.maxWidth} - ${offsetRightPx}px)`,
});

const desktopSupportWindowStyles = {
  bottom: '16px',
  display: 'block',
  height: '100%',
  left: 'unset',
  maxHeight: `calc(100% - 32px)`,
  maxWidth: '100%',
  right: '16px',
  width: '668px',
};

export const getDesktopSupportWindowStyles = ({ size = 'large' }: GetStylesParams) => {
  const sizePreset = WIDGET_SIZE_PRESETS[size];

  return {
    ...desktopSupportWindowStyles,
    width: sizePreset.width,
    maxHeight: getViewportConstrainedMaxHeight(size),
    bottom: desktopSupportWindowStyles.bottom,
    right: desktopSupportWindowStyles.right,
  };
};

const mobileSupportWindowStyles = {
  bottom: '0px',
  display: 'block',
  height: '100%',
  left: '0px',
  maxHeight: '100%',
  maxWidth: '100%',
  right: '0px',
  width: '100%',
};

export const getMobileSupportWindowStyles = () => ({
  ...mobileSupportWindowStyles,
  bottom: mobileSupportWindowStyles.bottom,
  right: mobileSupportWindowStyles.right,
  maxHeight: mobileSupportWindowStyles.maxHeight,
  maxWidth: mobileSupportWindowStyles.maxWidth,
});

const mobileDefaultStyles = {
  bottom: '0px',
  display: 'block',
  height: '128px',
  left: '0px',
  maxHeight: '100%',
  maxWidth: '100%',
  right: '0px',
  width: '100%',
};

export const getMobileDefaultStyles = ({ offsetBottomPx = 0, offsetRightPx = 0 }: GetStylesParams) => ({
  ...mobileDefaultStyles,
  bottom: `calc(${mobileDefaultStyles.bottom} + ${offsetBottomPx}px)`,
  right: `calc(${mobileDefaultStyles.right} + ${offsetRightPx}px)`,
  maxHeight: `calc(${mobileDefaultStyles.maxHeight} - ${offsetBottomPx}px)`,
  maxWidth: `calc(${mobileDefaultStyles.maxWidth} - ${offsetRightPx}px)`,
});

export const collapsedStyles = {
  display: 'block',
  left: 'unset',
  maxHeight: '110px',
  maxWidth: '110px',
};
